<div class="modal-overlay">
  <div class="modal-container">
    <div class="modal-header">
      <div>
        <h2>Invite Specific Candidates</h2>
        <p>Restrict access to invited email addresses.</p>
      </div>
      <span class="close-btn" (click)="closeDialog()">
        <i class="bi bi-x"></i>
      </span>
    </div>

    <div class="modal-body">
      <div class="bulk-email-box">
        <p class="title">Bulk add candidate emails</p>

        <textarea
          rows="4"
          placeholder="e.g. alice@example.com, bob@example.com"
          [(ngModel)]="invitedEmailsInput"
        ></textarea>

        <div class="bottom-row">
          <span class="hint">Separate by commas, spaces or new lines</span>

          <span>
            <button
              class="btn-add"
              type="button"
              (click)="addEmails()"
              [disabled]="!invitedEmailsInput.trim()"
            >
              <i class="bi bi-envelope me-1"></i>
              Add to invite list
            </button>
          </span>
        </div>

        <div class="chips-container" *ngIf="invitedEmailList.length > 0">
          <div class="selected-title">
            NEW INVITATIONS ({{ invitedEmailList.length }})
          </div>

          <div class="chip-row">
            <span class="chip" *ngFor="let email of invitedEmailList">
              {{ email }}
              <i class="bi bi-x" (click)="removeEmail(email)"></i>
            </span>
          </div>
        </div>

        
      </div>
    </div>

    <div class="modal-footer">
      <button
        class="generate-btn cancel"
        type="button"
        (click)="closeDialog()"
      >
        Cancel
      </button>
      <button
        class="generate-btn"
        type="button"
        [disabled]="invitedEmailList.length === 0 || isLoading"
        (click)="sendInvite()"
      >
        <ng-container *ngIf="isLoading; else showText">
          <span class="spinner-text">
            <mat-spinner [diameter]="20" class="spinner-white"></mat-spinner>
            Sending...
          </span>
        </ng-container>
        <ng-template #showText> Send Invite </ng-template>
      </button>
    </div>
  </div>
</div>
